<!-- 红包发放统计 -->
<template>
  <div class='content'>
    <el-form ref="form" label-width="auto" align="left" :inline="true">
      <el-form-item label="手机号：">
        <el-input placeholder="输入手机号" @change="getTableList()" v-model="params.userMobile"></el-input>
      </el-form-item>
      <el-form-item label="发放状态：">
        <el-select v-model="params.packetStatus">
          <el-option value="" label="全部"></el-option>
          <el-option value="0" label="待领取"></el-option>
          <el-option value="1" label="领取中"></el-option>
          <el-option value="2" label="领取成功"></el-option>
          <el-option value="3" label="领取失败"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间段：">
        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="dateChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getTableList()">搜索</el-button>
        <el-button size="small" @click="resetParams();getTableList();">重置</el-button>
        <!-- <el-button size="small" type="primary" @click="title='新增广告';resetForm();dialogVisible=true">新增</el-button> -->
      </el-form-item>
    </el-form>

    <el-table 
      :data="tableData"
      class="mt-20"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}">
      <!-- show-overflow-tooltip -->
      <el-table-column label="手机号" prop="userMobile"></el-table-column>
      <el-table-column label="收款账号" prop="packetAccount"></el-table-column>
      <el-table-column label="姓名" prop="userName"></el-table-column>
      <el-table-column label="身份证号" prop="certNo"></el-table-column>
      <el-table-column label="红包类型" prop="packetType">
        <template slot-scope="scope">
          <span v-if="scope.row.packetType == 0">微信红包</span>
          <span v-if="scope.row.packetType == 1">支付宝红包</span>
        </template>
      </el-table-column>
      <el-table-column label="红包金额" prop="packetValue">
        <template slot-scope="scope">￥{{ (scope.row.packetValue/10000).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="发放状态" prop="packetStatus">
        <template slot-scope="scope">
          <span v-if="scope.row.packetStatus == 0">待领取</span>
          <span v-if="scope.row.packetStatus == 1">领取中</span>
          <span v-if="scope.row.packetStatus == 2">领取成功</span>
          <span v-if="scope.row.packetStatus == 3">领取失败</span>
        </template>
      </el-table-column>
      <el-table-column label="发放时间" prop="packetTime"></el-table-column>
      <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
      <el-pagination 
        small layout="total,prev,pager, next,sizes,jumper" 
        :page-size="params.pageSize"
        :total="total" 
        :current-page.sync="params.pageNum" 
        :page-sizes="[10 ,20 , 30, 40, 50]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>
  </div>
</template>
 
<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
 
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    //ComponentName和文件名保持一致
    name:'packetRecord',
    data() {
      //这里存放数据
      return {
        params:{
          pageNum: 1,
          pageSize: 10,
          userMobile: '',
          packetStatus: '',
          packetStartTime: '',
          packetEndTime: ''
        },
        time: [],
        tableData: [],
        total: 0,
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      /**获取列表数据 */
      getTableList(){
        this.ajax.fetch({
          url: this.apis.packetRecord.get,
          disableLoading: true,
          method: 'post',
          param: this.params,
          successFunc: res=>{
            this.total = res.total;
            this.tableData = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      resetParams(){
        this.params={
          pageNum: 1,
          pageSize: 10,
          userMobile: '',
          packetStatus: '',
          packetStartTime: '',
          packetEndTime: ''
        }
      },
      dateChange(value) {
        this.params.packetStartTime = value[0];
        this.params.packetEndTime = value[1];
      },
      handleSizeChange(page) {
        this.params.pageSize = page;
        this.getTableList();
      },
      handleCurrentChange(val){
        this.params.pageNum = val;
        this.getTableList();
      },
    },
    beforeCreate() {}, //生命周期 - 创建之前
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    beforeMount() {}, //生命周期 - 挂载之前
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getTableList();
    },
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    deactivated() {}, //如果页面有keep-alive缓存功能，当组件被移除时，触发钩子函数deactivated
  }
</script>

<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/page/activityManage/packetRecord/packetRecord.vue